import {
  BankDossier,
  BankMilestoneKey,
  bankMilestoneKeys,
} from '../../../../api/workOrders/bankDossier';
import { Constants } from '../../../../constants/bankDossier';
import {
  dossierDate,
  dossierDateTime,
  dossierTime,
} from '../../../../helpers/bankDossier';
import { Field, FieldGrid, FieldGroup } from '../../../UI/FieldGrid';
import {
  Milestone,
  MilestoneDate,
  MilestoneDot,
  MilestoneLabel,
  MilestoneTime,
  Timeline,
  TimelineEmpty,
} from '../styles';

interface SectionProps {
  dossier: BankDossier;
}

const { fields } = Constants.timeline;

export function TimelineSection({ dossier }: SectionProps): JSX.Element {
  const { milestones } = dossier;
  const now = Date.now();

  const filled = bankMilestoneKeys
    .filter((key) => milestones[key])
    .map((key: BankMilestoneKey) => ({
      key,
      value: milestones[key] as string,
      label: fields[key],
    }))
    .sort((a, b) => new Date(a.value).getTime() - new Date(b.value).getTime());

  return (
    <>
      <FieldGroup title={Constants.timeline.timelineTitle}>
        {filled.length === 0 ? (
          <TimelineEmpty>{Constants.timeline.empty}</TimelineEmpty>
        ) : (
          <Timeline>
            {filled.map((milestone, index) => {
              const isFuture = new Date(milestone.value).getTime() > now;
              return (
                <Milestone
                  key={milestone.key}
                  isLast={index === filled.length - 1}
                  isFuture={isFuture}
                >
                  <MilestoneDot isFuture={isFuture} />
                  <MilestoneDate>
                    {dossierDate(milestone.value)}
                    <MilestoneTime>
                      {dossierTime(milestone.value)}
                    </MilestoneTime>
                  </MilestoneDate>
                  <MilestoneLabel>{milestone.label}</MilestoneLabel>
                </Milestone>
              );
            })}
          </Timeline>
        )}
      </FieldGroup>

      <FieldGroup title={Constants.timeline.datesTitle}>
        <FieldGrid minColumn={200}>
          {bankMilestoneKeys.map((key) => (
            <Field
              key={key}
              label={fields[key]}
              value={dossierDateTime(milestones[key])}
              mono
            />
          ))}
        </FieldGrid>
      </FieldGroup>
    </>
  );
}
